import { v4 as uuidv4 } from 'uuid'

import { ReactComponent as ArrowIcon } from 'assets/svg/arrow.svg'
import { ReactComponent as NotificationIcon } from 'assets/svg/joinUs.svg'

const navigation2025 = [
  {
    id: uuidv4(),
    title: 'About Community Day',
    link: 'ABOUT-COMMUNITY-DAY',
  },
  {
    id: uuidv4(),
    title: 'Recordings/Gallery',
    link: 'RECORDING',
  },
  {
    id: uuidv4(),
    title: 'Speakers',
    link: 'SPEAKERS',
  },
  {
    id: uuidv4(),
    title: 'Sponsors',
    link: 'SPONSORS',
  },
  {
    id: uuidv4(),
    title: 'Team',
    link: 'TEAM',
  },
  {
    id: uuidv4(),
    title: 'Past events',
    link: '/events/2024',
    isLink: true,
    Icon: ArrowIcon,
  },
  {
    id: uuidv4(),
    title: 'Join Us',
    link: 'FOOTER',
    Icon: NotificationIcon,
  },
]

export default navigation2025
